export default __webpack_public_path__ + "static/media/69.d517260b.jpg";